import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: Returns true when IS_TOKEN_COST_USAGE_ENABLED is "true" on the server.
// UI-only flag — the /token-usage/by-model API stays reachable (and owner-only)
// regardless; this hook just gates whether the standalone Token & Cost Usage
// route + nav entry are surfaced (NSAI-4367).
export const useTokenCostUsageEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.features.isTokenCostUsageEnabled ?? false;
};
